<template>
  <SmartHrLocalList module-type="SAFETY" title="用工安全" group-name="员工管理"/>
</template>
<script>
import SmartHrLocalList from './SmartHrLocalList'
export default {
  name: 'SmartHrSafety',
  components: { SmartHrLocalList }
}
</script>



// WEBPACK FOOTER //
// SmartHrSafety.vue?048c2376